import React from 'react';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import AdminRolesForm from 'features/layout/DialogRoutes/dialogs/settings/AdminRolesDialog/AdminRolesForm';
import {RoleListProps} from 'features/layout/DialogRoutes/dialogs/settings/AdminRolesDialog/RolesList';
import {IDiplomatObject} from 'types/DiplomatObject';
import {useModal} from 'common/hooks/useModal';
import {useFieldArray} from 'react-hook-form';
import {AddPermissionEntryDialog} from 'features/layout/DialogRoutes/dialogs/settings/PermissionsDialog/AddPermissionEntryDialog';
import {RoleNames} from 'types/diplomat/settings/RoleNames';
import {useDeletePermission} from 'redux/settings/hooks/useDeletePermission';
import {DiplomatObjectType, DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';
import {IDiplomatFolder} from 'types/DiplomatFolder';
import {isSFTP, isTransactionOrSyncByType} from 'common/diplomatObjectUtils';
import {
   DiplomatObjectAceType,
   IDiplomatObjectAceType,
} from 'types/diplomat/settings/permissions/DiplomatObjectAceType';
import {TRANSACTIONS_FOLDER_NAME} from 'features/layout/redux/helpers/utils';

type Props = {
   refetch: RoleListProps['refetch'];
   onClose: (result?: string) => void;
   data: IDiplomatFolder;
};
export const PermissionsFormWrapper = ({onClose, refetch, data}: Props) => {
   const {fields, remove, append} = useFieldArray({name: RoleNames.roles, keyName: '_id' as 'id'});
   // const roles = useFieldValue<IAdminRoles>(RoleNames.roles) as IAdminRoles['roles'];

   // const {request, state: resourceTypes, loading} = useGetApi(api.resourcetypes);
   // React.useEffect(request, [request]);

   const {open: addOpened, handleClose: closeAdd, handleOpen: openAdd} = useModal(false);
   // const onCreate = () => console.log('Add');
   const onDelete = useDeletePermission(refetch, data.objectType, data._id || data.id);

   // console.debug(data);
   const resourceType = usePermissionResourceType(data.name, data.objectType, data.childObjectType);
   const [selected, select] = React.useState<IDiplomatObject>();

   return (
      <div>
         <AdminRolesForm
            vertical
            refetch={refetch}
            onCreate={openAdd}
            onDelete={onDelete}
            selected={selected}
            select={select}
            resourceTypes={resourceType}
            labels={DiplomatObjectAceType.origin}
            hideItemsMenu
         />
         <FormFooterButtons cancel={onClose} />
         {addOpened && (
            <AddPermissionEntryDialog
               permissionEntries={fields as IDiplomatObject[]}
               onClose={(users?: IDiplomatObject[]) => {
                  if (users) {
                     users.forEach((user) => {
                        const newUser = {...user, resources: []};
                        append(newUser);
                        select(newUser);
                     });
                  }
                  closeAdd();
               }}
            />
         )}
      </div>
   );
};

const baseTypes = [
   DiplomatObjectAceType.enum['VIEW'],
   DiplomatObjectAceType.enum['MODIFY'],
   DiplomatObjectAceType.enum['PERMISSIONS'],
   DiplomatObjectAceType.enum['ADD_OBJECT'],
   DiplomatObjectAceType.enum['REMOVE_OBJECT'],
];

const folderTypes = [DiplomatObjectAceType.enum['SUSPEND_RELEASE']];

const transactionTypes = [DiplomatObjectAceType.enum['EXECUTE']];

function usePermissionResourceType(
   name: string,
   objectType: DiplomatObjectTypeUnion,
   childObjectType: DiplomatObjectTypeUnion
) {
   let types = baseTypes as IDiplomatObjectAceType[];

   if (objectType === DiplomatObjectType.enum.FOLDER && !isSFTP(childObjectType)) {
      types = [...types, ...folderTypes];
   }

   if (
      isTransactionOrSyncByType(childObjectType) ||
      isTransactionOrSyncByType(objectType) ||
      name === TRANSACTIONS_FOLDER_NAME
   ) {
      types = [...types, ...transactionTypes];
   }

   return types;
}
